import React, {useEffect,useState} from 'react';
import {confirmMailProject,readAllMailReviews,type MailReviewPage,type MailReviewRow} from '../../services/todayMailReview';

const priority = {urgent:'Urgent',time_sensitive:'Time sensitive',normal:'Normal'};
const when = new Intl.DateTimeFormat('en-AU',{dateStyle:'medium',timeStyle:'short',timeZone:'Australia/Sydney'});

function ReviewRow({row,busy,onConfirm}:{row:MailReviewRow;busy:boolean;onConfirm:(projectId:number)=>void}) {
  const [chosen,setChosen] = useState('');
  const candidate = row.candidates.find(item=>String(item.projectId) === chosen);
  return <li className="pcc-mail-row">
    <div><span className={'pcc-badge ' + (row.urgency === 'urgent' ? 'critical' : row.urgency === 'time_sensitive' ? 'medium' : '')}>{priority[row.urgency]}</span>
      {' '}<strong>{row.nextAction}</strong>{row.urgencyReason && <small>{row.urgencyReason}</small>}</div>
    <div><a href={'https://outlook.office.com/mail/deeplink/read/' + encodeURIComponent(row.messageId)} target="_blank" rel="noreferrer">{row.subject || 'Original email'}</a>
      <small>{row.direction === 'inbound' ? 'Received' : 'Sent'} · {row.fromEmail} · {when.format(new Date(row.occurredAt))} Sydney</small>
      {row.excerpt && <blockquote>{row.excerpt}</blockquote>}</div>
    <div>{row.candidates.length ? <><label>Candidate project<select aria-label={'Candidate project for '+row.subject} disabled={busy} value={chosen} onChange={e=>setChosen(e.target.value)}>
      <option value="">Select after checking the source</option>
      {row.candidates.map(c=><option key={c.projectId} value={c.projectId}>{c.projectNumber} · {c.address} {c.status && '('+c.status+')'} · {c.basis}</option>)}
    </select></label>
      <small>{candidate ? 'Matching clue: '+candidate.basis : 'Proposed: '+row.candidates.map(c=>c.projectNumber+' · '+c.address+' ('+c.basis+')').join(' / ')}</small>
      <button type="button" disabled={busy || !candidate} onClick={()=>candidate && onConfirm(candidate.projectId)}>Confirm project &amp; save suggestion</button></>
      : <small>No verified candidate to show. Check the original email.</small>}</div>
  </li>;
}

export default function TodayMailReview({plan}:{plan:object}) {
  const [revision,setRevision] = useState(0);
  const [data,setData] = useState<MailReviewPage|null>(null);
  const [failure,setFailure] = useState('');
  const [notice,setNotice] = useState('');
  const [saving,setSaving] = useState(false);
  useEffect(()=>{
    let active = true;
    setData(null); setFailure('');
    readAllMailReviews().then(result=>{if(active)setData(result);},error=>{
      if(active)setFailure(error instanceof Error ? error.message : 'Mail review unavailable.');
    });
    return ()=>{active=false;};
  },[plan,revision]);
  async function confirm(row:MailReviewRow,projectId:number) {
    if (!data || saving) return;
    setSaving(true); setNotice('');
    try {
      await confirmMailProject(row.messageId,projectId,data.revision);
      setNotice('Project confirmed. Follow-up saved in the project assistant.');
    } catch(error) {
      setNotice(error instanceof Error ? error.message : 'Refresh to verify the project link.');
    } finally {setRevision(n=>n+1);setSaving(false);}
  }
  return <section className="pcc-panel" aria-label="Mail awaiting project confirmation"><div className="pcc-section-heading"><div>
    <h2>Mail awaiting project confirmation</h2>
    <small>{data && !data.enrollmentRequired ? data.total+' pending · '+data.mailbox+' · Highest urgency first' : 'Your project mail assistant'}</small>
  </div></div>
    {notice && <p role="status">{notice}</p>}
    {failure ? <p role="status">{failure} <button type="button" onClick={()=>setRevision(n=>n+1)}>Retry mail review</button></p>
      : !data ? <p>Loading mail review…</p> : data.enrollmentRequired ? <p>Set up your project mail assistant to see pending mail here.</p>
      : <>{data.candidateCoverage === 'unavailable' && <p role="status">Some project candidates could not be checked. Refresh before confirming a match.</p>}
        {data.legacyUnresolved > 0 && <p>{data.legacyUnresolved} older unmatched records have no stored source details for review.</p>}
        {data.items.length ? <ol className="pcc-mail-list">{data.items.map(row=><ReviewRow key={row.messageId} row={row} busy={saving} onConfirm={id=>void confirm(row,id)}/>)}</ol>
          : <p>No actionable mail awaiting project confirmation.</p>}</>}
  </section>;
}
